const C = {
  name: "Watch2",
  dimensions: { width: 40, height: 40 },
  content: `
    <g fill="currentColor" stroke="none">
    <path d="M24 22V18H25C25.55 18 26 18.45 26 19V22H24ZM22 30C22 31.1 21.1 32 20 32H4C2.9 32 2 31.1 2 30V10C2 8.9 2.9 8 4 8H20C21.1 8 22 8.9 22 10V16V24V30ZM17.28 38H7.44C7.01 38 6.63 37.72 6.49 37.32L5.39 34H17.92C18.26 34 18.5 34.33 18.39 34.66L17.28 38ZM6.72 2H16.56C16.99 2 17.37 2.28 17.51 2.68L18.61 6H6.08C5.74 6 5.5 5.67 5.61 5.34L6.72 2ZM26 16H24V10C24 8.05 22.6 6.43 20.75 6.08L19.18 1.37C18.9 0.55 18.14 0 17.28 0H6.72C5.86 0 5.1 0.55 4.82 1.37L3.25 6.08C1.4 6.43 0 8.05 0 10V30C0 31.95 1.4 33.57 3.25 33.92L4.82 38.63C5.1 39.45 5.86 40 6.72 40H17.28C18.14 40 18.9 39.45 19.18 38.63L20.75 33.92C22.6 33.57 24 31.95 24 30V24H26C27.1 24 28 23.1 28 22V18C28 16.9 27.1 16 26 16Z" />
    <path d="M17 14H7C6.45 14 6 14.45 6 15C6 15.55 6.45 16 7 16H17C17.55 16 18 15.55 18 15C18 14.45 17.55 14 17 14Z" />
    <path d="M17 19H7C6.45 19 6 19.45 6 20C6 20.55 6.45 21 7 21H17C17.55 21 18 20.55 18 20C18 19.45 17.55 19 17 19Z" />
    <path d="M17 24H7C6.45 24 6 24.45 6 25C6 25.55 6.45 26 7 26H17C17.55 26 18 25.55 18 25C18 24.45 17.55 24 17 24Z" />
    </g>
  `
};
export {
  C as Watch2
};
